import React from 'react';
import companyBenefitGroupStyles from './CompanyBenefitGroup.module.css';

export function CompanyBenefitGroup(props) {
  return <div className={companyBenefitGroupStyles['company-benefit-group']}>{props.children}</div>;
}
